import { render, staticRenderFns } from "./class-builder-placeholder.view.vue?vue&type=template&id=fbf164f4&scoped=true&"
import script from "./class-builder-placeholder.view.ts?vue&type=script&lang=ts&"
export * from "./class-builder-placeholder.view.ts?vue&type=script&lang=ts&"
import style0 from "./class-builder-placeholder.view.scss?vue&type=style&index=0&id=fbf164f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf164f4",
  null
  
)

export default component.exports